/** Build-time provenance. The ONLY build variable in this app. */
export interface AppEnv {
  deployEnv: string;
}

export const env: AppEnv = {
  deployEnv: import.meta.env.VITE_DEPLOY_ENV?.trim() || 'local',
};
